import * as React from "react";
import { Layout, Box, Text, Flex, InfoCircleIcon } from "@draftkings/arena-web";
export const EarlyWin = React.memo(function EarlyWin(props) {
    const { label, status, messages, openModal, purchaseId, testId } = props;
    const handleKeyDown = React.useCallback((e) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            openModal === null || openModal === void 0 ? void 0 : openModal();
        }
    }, [openModal]);
    return React.createElement(Layout, { variant: "bonus" },
        React.createElement(Flex, { gap: "8px", alignItems: "center" },
            React.createElement(Box, { testId: testId, variant: `button.earlyWin:${status}` }, label)),
        messages.map((message, index) => React.createElement(Flex, { key: `${purchaseId}-${index}`, gap: "4px", alignItems: "center", fontSize: index === 0 ? "12px" : "initial", paddingBottom: index === 0 ? "8px" : "initial" },
            React.createElement(Text, { testId: `message-${purchaseId}-${index}`, variant: `boostMessage${message.type}` }, message.text),
            index === 0 && openModal && React.createElement("div", { "data-testid": `early-win-info-icon-${purchaseId}`, role: "button", tabIndex: 0, onClick: openModal, onKeyDown: handleKeyDown, style: { cursor: "pointer", display: "inline-flex", alignItems: "center", color: "rgb(171, 171, 171)" } },
                React.createElement(InfoCircleIcon, { maxWidth: "16px", maxHeight: "16px", accessibilityText: "Early Win info" })))));
});
//# sourceMappingURL=EarlyWin.js.map